export const GET_DISEASES_BY_FILTER_REQUEST = "GET_DISEASES_BY_FILTER_REQUEST"
export const GET_DISEASES_BY_FILTER_SUCCESS = "GET_DISEASES_BY_FILTER_SUCCESS"
export const GET_DISEASES_BY_FILTER_FAILURE = "GET_DISEASES_BY_FILTER_FAILURE"